angular.module('unergie.main')
.controller('estimateTimetableModalCtrl', ($scope, $timeout, $uibModalInstance, ApiUser, ReferencesService, timetables, NgTableParams, AuthService, ErrorCatcher) => {
    $scope.ttToMoment = (tt) => moment(`${tt.month}/${tt.year}`, 'M/YYYY')

    if (!timetables || (timetables.length === 0) || !angular.isArray(timetables)) {
        $uibModalInstance.dismiss()
    } else {
        let colored = false
        $scope.timetables = timetables

        const firstTt = timetables[0]
        const lastTt = timetables[timetables.length - 1]

        $scope.period = [{
            sleeked: firstTt.sleeked,
            date: $scope.ttToMoment(firstTt),
        }]
        _.forEach(timetables, (tt) => {
            if (tt.nextReading) {
                $scope.period.push({
                    sleeked: tt.sleeked,
                    date: $scope.ttToMoment(tt),
                })
                colored = !colored
            }
            tt.colored = colored
            return true
        }) // pour ne pas casser le forEach
        $scope.period.forEach((p, i) => {
            if (i) {
                return ($scope.period[i - 1].date = p.date)
            }
        })

        $scope.period[$scope.period.length - 1].date = $scope.ttToMoment(lastTt)
        $scope.tableParams = new NgTableParams({ sorting: { year: 'asc', month: 'asc' }, count: 12 }, { counts: [], dataset: timetables })
    }

    $scope.close = () => $uibModalInstance.dismiss()

    $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])
})
